import styled, { css } from 'styled-components';
import { getSpace } from '../../../foundation/theme/space.utils';
import { MAPPINGS_MODE } from './FormGroup.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const FormGroupRoot = styled.div `
  ${({ mode, position, hasLabel }) => {
    const { color } = MAPPINGS_MODE[mode];
    return css `
      /* Common. */
      background-color: transparent;
      color: ${color};
      display: grid;

      /* Box model. */
      grid-template-columns: ${position === 'stacked'
        ? 'auto'
        : 'minmax(auto, max-content) auto'};
      grid-template-rows: ${position === 'stacked' ? 'auto' : 'auto auto'};
      grid-gap: ${hasLabel ? `0 ${getSpace('s')}` : 0};

      .ui-fg-label {
        align-self: center;
        grid-row: 1/2;
        grid-column: 1/2;
      }

      .ui-fg-field {
        align-self: center;
        ${position === 'stacked'
        ? `
          grid-row: 2/3;
          grid-column: 1/2;
        `
        : `
          grid-row: 1/2;
          grid-column: 2/3;
        `}
      }

      .ui-fg-explain {
        ${position === 'stacked'
        ? `
          grid-row: 3/4;
          grid-column: 1/2;
        `
        : `
          grid-row: 2/3;
          grid-column: 2/3;
        `}
      }
    `;
}}
`;
//# sourceMappingURL=FormGroup.styled.js.map